// All content sourced directly from the Buildaxis Developers / Central Plaza brochure.
export const CONTACT = {
  phone1: "+91 8685888852",
  phone2: "+91 8685888853",
  phone1Tel: "+918685888852",
  phone2Tel: "+918685888853",
  email: "info.central@buildaxisdevelopers.com",
  website: "www.buildaxisdevelopers.com",
  whatsapp: "918800215819",
  whatsappDisplay: "+91 88002 15819",
  tel: "+918685888852",
  address: "Sector 10A, Kharkhoda, Sonipat, Haryana",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const IMAGE_DISCLAIMER =
  "Images are for representation and illustration purposes only. Actual product, layout, and finishes may vary.";

/** PropVision public website lead capture — POST /leads/website */
export const LEADS_API = {
  baseUrl:
    process.env.REACT_APP_LEADS_API_BASE ||
    process.env.REACT_APP_PROVISION_API_URL ||
    "https://propvision-backend-production.up.railway.app",
  clientId: process.env.REACT_APP_CLIENT_ID || "client_buildaxis_main",
};

/** HRERA registration — Central Plaza (Sector 10A, Kharkhoda) */
export const RERA = {
  number: "HRERA-PKL-SNP-995-2026",
  registeredOn: "16 October 2026",
  projectName: "Central Plaza",
  location: "Revenue estate of village Barona, Sector-10A, Kharkhoda, District Sonipat, Haryana",
  promoter: "Buildaxis Developers Pvt Ltd",
  licenseNo: "149 of 2026",
  licenseDate: "25 July 2026",
  licenseValidUntil: "24 July 2031",
  authority: "Haryana Real Estate Regulatory Authority, Panchkula",
};

export const HIGHLIGHTS = [
  {
    num: "01",
    title: "Premium 16 SCO Units",
    desc: "An exclusive collection of sixteen Shop-cum-Office units crafted for enduring commercial value.",
  },
  {
    num: "02",
    title: "Basement + 4 Floors",
    desc: "A generous permitted footprint allowing retail, office and lifestyle formats to flourish vertically.",
  },
  {
    num: "03",
    title: "45 Meter Wide Road",
    desc: "Frontage onto Sector Road VIII — one of Kharkhoda's widest and most prominent commercial arteries.",
  },
  {
    num: "04",
    title: "12 Meter Service Road",
    desc: "A dedicated service lane ensures seamless access, deliveries and uninterrupted customer footfall.",
  },
  {
    num: "05",
    title: "3 Side Open Project",
    desc: "Triple-side openness delivers superior light, ventilation and visibility for every single unit.",
  },
  {
    num: "06",
    title: "Developer Controlled Facade",
    desc: "A uniform, architect-designed facade preserves the complex's premium street presence for years.",
  },
  {
    num: "07",
    title: "High Rental Yield",
    desc: "Positioned to command strong lease demand as Kharkhoda's commercial ecosystem matures rapidly.",
  },
  {
    num: "08",
    title: "Strong ROI Potential",
    desc: "A rare first-mover advantage in one of the NCR's fastest industrialising growth corridors.",
  },
];

export const WHY_INVEST = [
  {
    icon: "MapPinned",
    title: "Namo City — KMP Corridor",
    desc:
      "Haryana has begun developing Namo City, a ~9,000-acre greenfield urban centre along the KMP Expressway — a state-scale anchor for growth across Sonipat, Kharkhoda and the wider NCR industrial belt.",
    href: "https://theprint.in/india/governance/haryana-begins-process-to-develop-namo-city-a-9000-acre-greenfield-urban-centre-along-kmp-corridor/3040099/",
    linkLabel: "Read coverage in The Print",
  },
  {
    icon: "Factory",
    title: "Maruti Suzuki Manufacturing Hub",
    desc: "Maruti Suzuki, along with its vendor ecosystem, is undergoing rapid expansion at IMT Kharkhoda — just 6 km away.",
  },
  {
    icon: "TrendingUp",
    title: "Rapid Industrial Development",
    desc: "IMT Kharkhoda is emerging as one of North India's fastest growing manufacturing hubs.",
  },
  {
    icon: "Route",
    title: "Excellent Connectivity",
    desc: "Seamless access via KMP Expressway, GT Road, UER-2, NH-334B and the new elevated road from Bawana.",
  },
  {
    icon: "LineChart",
    title: "High Future Appreciation",
    desc: "Early investors in Kharkhoda are already witnessing high returns as infrastructure matures.",
  },
  {
    icon: "Users",
    title: "Growing Population",
    desc: "Over 21,000 direct jobs from the fully developed Kharkhoda manufacturing complex will fuel demand.",
  },
  {
    icon: "Building2",
    title: "Strong Commercial Demand",
    desc: "A scarcity of organised retail and office space in Kharkhoda creates immediate footfall potential.",
  },
];

export const LOCATION_ADVANTAGES = [
  { icon: "Milestone", label: "NH-334B", value: "100 m" },
  { icon: "Factory", label: "IMT Kharkhoda", value: "6 km" },
  { icon: "Car", label: "Maruti Suzuki Plant", value: "6 km" },
  { icon: "Route", label: "KMP Expressway", value: "5 km" },
  { icon: "TrainFront", label: "Sonipat Railway Station", value: "20 km" },
  { icon: "Landmark", label: "Bahadurgarh Metro", value: "30 km" },
  { icon: "MapPin", label: "Delhi Border", value: "12 km" },
  { icon: "Plane", label: "IGI Airport", value: "65 km" },
  { icon: "Signpost", label: "Jammu Katra Highway", value: "10 km" },
  { icon: "Navigation", label: "G.T. Karnal Road", value: "24 km" },
];

export const UNIT_SIZES = [
  { size: 99.67, units: 3, unitNos: "A10, A11, A12" },
  { size: 100.46, units: 4, unitNos: "A6 – A9" },
  { size: 115.53, units: 4, unitNos: "A12a – A16" },
  { size: 135.44, units: 3, unitNos: "A2, A3, A4" },
  { size: 157.54, units: 1, unitNos: "A5" },
  { size: 300.94, units: 1, unitNos: "A1" },
];

export const PRICING = {
  fromCr: 1.6,
  upToCr: 6.3,
  minSizeSqYd: 99.67,
  maxSizeSqYd: 300.94,
  /** Legacy brochure rate — used only for rounded indicative crore estimates */
  legacyRatePerSqYd: 190000,
  legacyGstFactor: 1.05,
};

export const formatCr = (cr) =>
  `₹${cr.toLocaleString("en-IN", { minimumFractionDigits: cr % 1 === 0 ? 0 : 1, maximumFractionDigits: 1 })} Cr`;

/** Rounded “starting from” crore estimate (not an exact quote). */
export const indicativeStartingCr = (sizeSqYd) => {
  const { legacyRatePerSqYd, legacyGstFactor, fromCr, upToCr } = PRICING;
  const totalInr = sizeSqYd * legacyRatePerSqYd * legacyGstFactor;
  const cr = Math.round((totalInr / 1e7) * 10) / 10;
  return Math.min(upToCr, Math.max(fromCr, cr));
};

export const PAYMENT_PLAN = [
  { step: "Booking Amount", amount: "₹10 Lacs", period: "Within 30 Days" },
  { step: "Installment 1", amount: "20%", period: "Within 30 Days" },
  { step: "Installment 2", amount: "25%", period: "Within 3 Months of Booking" },
  { step: "Installment 3", amount: "25%", period: "Within 5 Months of Booking" },
  { step: "Installment 4", amount: "25%", period: "Within 6 Months of Booking" },
];

export const TIMELINE_2026 = [
  { month: "JUN", label: "LOI Received", status: "done" },
  { month: "JUL", label: "License Received", status: "done" },
  { month: "OCT", label: "RERA Registered", status: "done" },
  { month: "NOV", label: "Deliver to Client", status: "upcoming" },
];

export const PERMISSIONS = [
  { label: "License Received", done: true },
  { label: "Layout Approved", done: true },
  { label: "Demarcation", done: false, note: "Submitted, awaiting approval" },
  { label: "Standard Layout", done: false, note: "In Process" },
  { label: "RERA Registered", done: true, note: RERA.number },
];

export const FAQS = [
  {
    q: "What is Central Plaza?",
    a: "Central Plaza is the first-ever premium SCO (Shop-cum-Office) complex in Kharkhoda, developed by Buildaxis Developers at Sector 10A, Kharkhoda, Sonipat.",
  },
  {
    q: "What is the total project area?",
    a: "Buildaxis is developing 2.705 acres in Sector 10A, Kharkhoda, of which 1.196 acres is dedicated to the Central Plaza SCO commercial complex.",
  },
  {
    q: "What is the price of an SCO unit?",
    a: "Exclusive pre-launch offer pricing is indicative only — units start from approximately ₹1.6 Cr, with larger configurations up to around ₹6.3 Cr. Connect with our sales team for unit-specific quotes.",
  },
  {
    q: "How many floors are permitted?",
    a: "Central Plaza permits Basement + 4 Floors, giving owners flexibility across retail, office and F&B formats.",
  },
  {
    q: "What is the road width and frontage?",
    a: "Central Plaza enjoys frontage on a 45-meter wide sector road (Sector Road VIII) with an additional 12-meter service road.",
  },
  {
    q: "Why invest in Kharkhoda?",
    a: "Kharkhoda is home to the upcoming Maruti Suzuki manufacturing plant (IMT Kharkhoda) and is rapidly industrialising, with excellent connectivity via KMP Expressway, NH-334B and GT Road — driving strong future demand for commercial space.",
  },
  {
    q: "What is Namo City and how is it linked to Sonipat?",
    a: "Namo City is a planned greenfield urban centre of roughly 9,000 acres along the Kundli–Manesar–Palwal (KMP) Expressway and the upcoming Delhi–Katra Expressway. Haryana Shehri Vikas Pradhikaran (HSVP) has earmarked villages in Sonipat, Jhajjar and Rohtak for the project — including several revenue villages in Sonipat district. Kharkhoda (Sector 10A), where Central Plaza and Central Heights are located, sits in the same Sonipat–KMP growth belt, so state-led township scale nearby can support long-term demand for housing and high-street commercial space.",
  },
  {
    q: "What is planned at Namo City?",
    a: "HSVP describes Namo City as a mixed-use centre with residential, commercial and industrial zones, plus schools, hospitals, parks and organised retail. The blueprint targets modern roads, time-bound clearances and public transport access within about 30 minutes of homes, with proposed linkage to the wider Namo Bharat regional rail (RRTS) network. Basic infrastructure is expected from the state, with private participation in development — similar to other HSVP-led greenfield nodes.",
  },
  {
    q: "How could Namo City affect future opportunity near Buildaxis?",
    a: "Large planned cities along KMP tend to pull employment, logistics and daily footfall into the corridor — complementing industrial anchors such as IMT Kharkhoda. Early SCO and apartment inventory at Kharkhoda can benefit from rising visibility, connectivity and township-style amenities as Sonipat and neighbouring districts urbanise. Timelines and land assembly can evolve; treat Namo City as one of several long-term regional drivers alongside expressway access and industrial growth, not a guarantee of short-term appreciation.",
  },
  {
    q: "What is the RERA registration for Central Plaza?",
    a: "Central Plaza is registered with the Haryana Real Estate Regulatory Authority, Panchkula under registration number HRERA-PKL-SNP-995-2026 (registered 16 October 2026). The promoter license (No. 149 of 2026) is valid until 24 July 2031. See the RERA section on this page for full details.",
  },
];

export const CENTRAL_HEIGHTS = {
  pdf: "/brochure/Buildaxis-Developers-Apartments-Details.pdf",
  ratePerSqFt: 7000,
  units: [
    {
      type: "2 BHK",
      sizeSqFt: 1000,
      units: 65,
      summary: "Compact family homes with balconies and modern layouts.",
      detail: "Ideal for end-use or rental demand near IMT Kharkhoda.",
    },
    {
      type: "3 BHK",
      sizeSqFt: 1500,
      units: 42,
      summary: "Spacious residences with living, dining and multiple balconies.",
      detail: "Suited for larger families seeking premium township living.",
    },
  ],
  paymentPlan: [
    { step: "Booking", amount: "5%", period: "Within 30 Days" },
    { step: "Installment 1", amount: "20%", period: "Within 30 Days" },
    { step: "Installment 2", amount: "10%", period: "Casting of Basement Slab 1" },
    { step: "Installment 3", amount: "10%", period: "Casting of Basement Slab 2" },
    { step: "Installment 4", amount: "10%", period: "Casting of 3rd Floor Slab" },
    { step: "Installment 5", amount: "10%", period: "Casting of 6th Floor Slab" },
    { step: "Installment 6", amount: "10%", period: "Casting of 9th Floor Slab" },
    { step: "Installment 7", amount: "10%", period: "Casting of 12th Floor Slab" },
    { step: "Installment 8", amount: "5%", period: "Start of Internal Finishing" },
    { step: "Installment 9", amount: "10%", period: "At Possession" },
  ],
  showcase: [
    {
      src: "/brochure/central-heights/exterior-render.png",
      alt: "Central Heights — residential apartments at Kharkhoda",
      label: "Residential Towers",
    },
    {
      src: "/brochure/central-heights/interior-living.png",
      alt: "Central Heights — living and dining interior",
      label: "Living & Dining",
    },
    {
      src: "/brochure/central-heights/interior-bedroom.png",
      alt: "Central Heights — master bedroom interior",
      label: "Master Bedroom",
    },
  ],
};

export const formatLakh = (inr) => {
  if (inr >= 1e7) return formatCr(inr / 1e7);
  const lakh = Math.round(inr / 1e5);
  return `₹${lakh.toLocaleString("en-IN")} Lakh`;
};

export const GALLERY = [
  { src: "/brochure/hero-day-render.png", alt: "Central Plaza — Daytime facade render, Sector 10A Kharkhoda" },
  { src: "/brochure/hero-night-render.png", alt: "Central Plaza — Evening render with retail frontage" },
  { src: "/brochure/about-siteplan-aerial.png", alt: "Central Plaza — Township aerial layout" },
  { src: "/brochure/site-plan-plots.png", alt: "Central Plaza — SCO plot layout plan" },
  { src: "/brochure/location-map.png", alt: "Central Plaza — Location & connectivity map" },
];
